/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Event, NavigationStart, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs/operators';
import { EventEmitter } from '@angular/core';

export abstract class EntryComponent {
  output: EventEmitter<{ type: string; payload: any }> = new EventEmitter<{
    type: string;
    payload: any;
  }>();

  constructor(
    protected prefix: string,
    protected router: Router,
    protected translateService: TranslateService
  ) {}

  abstract set input(input: string);

  handleInput(input: any) {
    const action = JSON.parse(input);
    if (action['type'] === 'langChange') {
      this.translateService.use(action['payload']['lang']);
    }
    if (action['type'] === 'routeChange') {
      // this.router.navigateByUrl(action['payload']['url']);
    }
  }

  init() {
    this.translateService.onLangChange.subscribe(({ lang }) => {
      this.output.emit({
        type: 'langChange',
        payload: {
          lang: lang,
        },
      });
    });

    this.router.initialNavigation();
    this.router.events
      .pipe(filter((event: Event): event is NavigationStart => event instanceof NavigationStart))
      .pipe(
        filter(
          (event) => !event.url.startsWith(`/${this.prefix}`)
        )
      )
      .subscribe((event: NavigationStart) => {
        this.output.emit({
          type: 'routeChange',
          payload: {
            url: event.url,
          },
        });
      });
  }
}
